import { useTheme } from '@mui/material';

export const TrashIcon = ({ type = 'basic' }: { type?: 'basic' | 'error' }) => {
  const { palette } = useTheme();
  const stroke =
    type === 'error' ? palette.error.main : palette.customGrey.medium;
  return (
    <svg width="12" height="16" viewBox="0 0 12 16" fill="none">
      <path
        d="M8.08317 0.499989L8.9165 1.33332H11.8332V2.99999H0.166504V1.33332H3.08317L3.9165 0.499989H8.08317ZM0.999843 13.8333C0.999843 14.75 1.74984 15.5 2.66651 15.5H9.33318C10.2498 15.5 10.9998 14.75 10.9998 13.8333V3.83331H0.999843V13.8333ZM2.66651 5.49998H9.33318V13.8333H2.66651V5.49998Z"
        fill={stroke}
        fillRule="evenodd"
        clipRule="evenodd"
      />
    </svg>
  );
};
